import { createSlice } from '@reduxjs/toolkit'

export const LOGED_IN = 'LOGED_IN'
export const LOGED_OUT = 'LOGED_OUT'
export const CHANGE_PASSWORD_CHALLENGE = 'CHANGE_PASSWORD_CHALLENGE'
export const EMAIL_VERIFICATION_CHALLENGE = 'EMAIL_VERIFICATION_CHALLENGE'
export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD'

const initialState = {
  authData: {
    authStatus: LOGED_OUT,
    jwtToken: '',
    email: '',
    emailVerified: false,
    groups: [],
  },
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateAuthData(state, action) {
      state.authData = action.payload
    },
  },
})

export const { updateAuthData } = authSlice.actions

export default authSlice.reducer
